<script>
import {Pie} from 'vue-chartjs'

export default {
  extends: Pie,
  data() {
    return {
      opportunity_data: {
        labels: ['Achieved', 'Opportunities'],
        datasets: [{
          label: '# of Bid Bonds per Tender',
          backgroundColor: ["rgba(255,99,132,1)","rgba(255,99,132,0.2)"],
          borderColor: "rgba(255,99,132,1)",
          data: [0, 1],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Revenue gotten from the opportunities',
          position: 'top'
        },
      }
    }
  },
  computed: {
    opportunity() {
      return this.$store.getters.getOpportunity;
    },
  },
  watch: {
    opportunity() {
      this.displayGraph();
    }
  },
  mounted() {
    this.displayGraph();
  },
  methods: {
    displayGraph() {
      this.opportunity_data.datasets[0]['data'] = [this.opportunity.achieved, this.opportunity.opportunity];
      this.renderChart(this.opportunity_data, this.options)
    }
  },
}
</script>
